<template>
    <div :class="!inline && $style.container">
        <svg width="100%"
             :class="$style.graph"
             :viewBox="`0 0 ${width + 5} ${height + 6}`">
            <g transform="translate(5, 3)">
                <g class="axis">
                    <template v-for="(_, i) in 11">
                        <text fill="#888"
                              x="0" :y="y(i * 10)"
                              alignment-baseline="mathematical"
                              font-size="2.5pt"
                              text-anchor="end"
                              v-text="i * 10" />
                        <path vector-effect="non-scaling-stroke"
                              :class="$style.line"
                              :d="`M2 ${y(i * 10)} L${width} ${y(i * 10)}`"/>
                    </template>
                </g>

                <g class="body" transform="translate(5, 0)">
                    <template v-for="course in visibleCourses">
                        <path :stroke="neutral(course.color)"
                              :key="course.id"
                              vector-effect="non-scaling-stroke"
                              :class="$style.grades"
                              :d="pointsForGrades(course.grades)" />
                        <circle v-for="(grade, index) in course.grades"
                                :key="grade.id"
                                :class="$style.grade"
                                :cx="x(index)"
                                :cy="y(grade.value)"
                                :fill="neutral(course.color)"
                                r="1" />
                    </template>
                </g>
            </g>
        </svg>

        <div class="row">
            <div v-for="course in validData" :key="course.id"
                 class="col-sm-6 pointer"
                 :class="{[$style.courseLabel]: true, [$style.active]: isValidCourse(course) }"
                 @click="toggleCourse(course)">
                <div class="media">
                    <div class="media-left">
                        <span class="course-color" :style="{
                            backgroundColor: isValidCourse(course) ? neutral(course.color) : 'transparent',
                        }" />
                    </div>
                    <div class="media-body" v-text="course.name" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import { scaleLinear } from 'd3-scale';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },

    inline: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      spacing: 10,
      width: 200,
      height: 80,
      hiddenIds: [],
    };
  },

  computed: {
    visibleCourses() {
      return _.filter(this.validData, this.isValidCourse);
    },

    validData() {
      return _.map(_.reject(this.data, ['type', 1]), course => ({
        id: course.id,
        name: course.name,
        color: course.color,
        grades: this.validGrades(course.grades),
      }));
    },

    /**
     * Determines the maximum count of exams of all courses in our data
     */
    maxExamCount() {
      return _.reduce(this.visibleCourses, (max, { grades }) => Math.max(max, grades.length), 1);
    },

    x() {
      return scaleLinear()
        .domain([0, Math.max(0, this.maxExamCount - 1)])
        .range([0, this.width - 10]);
    },

    y() {
      return scaleLinear()
        .domain([0, 100])
        .range([this.height, 0]);
    },
  },

  methods: {
    isValidCourse(course) {
      return this.hiddenIds.indexOf(course.id) < 0;
    },

    toggleCourse(course) {
      const idx = this.hiddenIds.indexOf(course.id);
      if (idx < 0) {
        this.hiddenIds.push(course.id);
      } else {
        this.hiddenIds.splice(idx, 1);
      }
    },

    pointsForGrades(grades) {
      const offset = this.width / this.maxExamCount / 2.5;

      return _.map(grades, ({ value }, index) => (index === 0
        ? `M${this.x(index)} ${this.y(value)}`
        : `C${this.x(index - 1) + offset} ${this.y(grades[index - 1].value)},`
                      + `${this.x(index) - offset} ${this.y(value)},${this.x(index)} ${this.y(value)}`
      )).join(' ');
    },

    validGrades(grades) {
      return _.reject(grades, ({ value }) => Number(value) !== value || value < 0);
    },
  },
};
</script>

<style lang='scss' module>
    .container {
        padding: 5px 15px 15px;
    }

    .graph {
        margin-bottom: 5px;
    }

    .line, .grades {
        fill: transparent;
    }

    .line {
        stroke-width: 1px;
        stroke: #eee;
    }

    .grades {
        stroke-width: 2px;
    }

    .courseLabel {
        font-size: 11px;
        margin-top: 5px;

        &.active {
            font-weight: 500;
        }

        :global(.course-color) {
            background-color: white;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/grades-chart.vue